import HNSColors from "../../../ui library/HNSColors";

export function getSettlementPdfStyles() {
  return `
    .settlement-pdf-document-title {
      color: ${HNSColors.primary[400]};
      font-size: 28px;
      font-weight: 700;
      line-height: 1.2;
      margin: 0;
      text-align: center;
      text-decoration: underline;
    }
    .settlement-pdf-table,
    .settlement-pdf-fee-list,
    .settlement-pdf-fee-layout {
      width: 100%;
      border-collapse: collapse;
    }
    .settlement-pdf-info-grid {
      background: ${HNSColors.tertiary[500]};
      color: ${HNSColors.neutrals[100]};
      border-radius: 12px;
      display: grid;
      gap: 0;
      padding: 18px 16px;
      width: 100%;
    }
    .settlement-pdf-info-row {
      display: grid;
      gap: 16px;
      grid-template-columns: minmax(180px, 220px) minmax(0, 1fr);
      padding: 12px 0;
    }
    .settlement-pdf-info-row + .settlement-pdf-info-row {
      border-top: 1px solid ${HNSColors.tertiary[600]};
    }
    .settlement-pdf-info-label {
      color: ${HNSColors.neutrals[100]};
      font-size: 14px;
      font-weight: 700;
    }
    .settlement-pdf-info-value {
      color: ${HNSColors.neutrals[100]};
      font-size: 16px;
      line-height: 1.35;
    }
    .settlement-pdf-table th {
      background: ${HNSColors.tertiary[900]};
      color: ${HNSColors.neutrals[300]};
      font-size: 13px;
      font-weight: 700;
      padding: 12px 10px;
      border: 1px solid ${HNSColors.tertiary[700]};
    }
    .settlement-pdf-table td {
      font-size: 13px;
      padding: 11px 10px;
      border: 1px solid ${HNSColors.tertiary[700]};
      vertical-align: middle;
    }
    .success-text { color: ${HNSColors.success[400]}; font-weight: 700; }
    .failure-text { color: ${HNSColors.failure[400]}; font-weight: 700; }
    .settlement-pdf-summary-grid {
      display: table;
      width: 100%;
      table-layout: fixed;
      border-spacing: 10px 0;
      margin-left: -10px;
      margin-right: -10px;
    }
    .settlement-pdf-summary-grid--2 .settlement-pdf-summary-card { width: 50%; }
    .settlement-pdf-summary-grid--4 .settlement-pdf-summary-card { width: 25%; }
    .settlement-pdf-summary-card {
      display: table-cell;
      background: ${HNSColors.tertiary[900]};
      border-radius: 12px;
      padding: 18px 16px;
      vertical-align: top;
    }
    .settlement-pdf-summary-card--success { background: ${HNSColors.success[700]}; }
    .settlement-pdf-summary-card--failure { background: ${HNSColors.failure[700]}; }
    .settlement-pdf-summary-table {
      background: ${HNSColors.tertiary[900]};
      border: 1px solid ${HNSColors.tertiary[700]};
      display: grid;
      overflow: hidden;
      width: 100%;
    }
    .settlement-pdf-summary-row {
      display: grid;
      grid-template-columns: minmax(220px, 260px) minmax(0, 1fr);
    }
    .settlement-pdf-summary-row + .settlement-pdf-summary-row {
      border-top: 1px solid ${HNSColors.tertiary[700]};
    }
    .settlement-pdf-summary-row--success {
      background: ${HNSColors.success[700]};
    }
    .settlement-pdf-summary-row--failure {
      background: ${HNSColors.failure[700]};
    }
    .settlement-pdf-summary-title {
      color: ${HNSColors.neutrals[300]};
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .settlement-pdf-summary-value { color: ${HNSColors.neutrals[100]}; font-size: 20px; font-weight: 700; }
    .settlement-pdf-summary-table .settlement-pdf-summary-title,
    .settlement-pdf-summary-table .settlement-pdf-summary-value {
      align-items: center;
      display: flex;
      margin: 0;
      padding: 12px 14px;
    }
    .settlement-pdf-summary-table .settlement-pdf-summary-value {
      font-size: 16px;
      justify-content: flex-start;
      text-align: left;
    }
    .settlement-pdf-summary-currency {
      display: inline-block;
      flex: 0 0 12px;
      text-align: left;
    }
    .settlement-pdf-summary-amount {
      display: inline-block;
      font-variant-numeric: tabular-nums;
      min-width: 96px;
      text-align: left;
    }
    .settlement-pdf-summary-card--success .settlement-pdf-summary-value { color: ${HNSColors.success[400]}; }
    .settlement-pdf-summary-card--failure .settlement-pdf-summary-value { color: ${HNSColors.failure[400]}; }
    .settlement-pdf-summary-row--success .settlement-pdf-summary-value { color: ${HNSColors.success[400]}; }
    .settlement-pdf-summary-row--failure .settlement-pdf-summary-value { color: ${HNSColors.failure[400]}; }
    .settlement-pdf-fee-layout td { vertical-align: top; }
    .settlement-pdf-fee-list td {
      padding: 12px 0;
      font-size: 15px;
      border-bottom: 1px solid ${HNSColors.tertiary[700]};
    }
    .settlement-pdf-fee-label {
      width: 220px;
    }
    .settlement-pdf-fee-value {
      text-align: left;
    }
    .settlement-pdf-fee-list-cell { padding-right: 24px; width: 52%; }
    .settlement-pdf-fee-chart-cell { width: 48%; text-align: center; }
    .settlement-pdf-pie-chart { margin: 0 auto; }
    .settlement-pdf-net-row--success td {
      background: ${HNSColors.success[700]};
      color: ${HNSColors.success[400]};
      font-weight: 700;
      border-bottom: none;
    }
    .settlement-pdf-net-row--failure td {
      background: ${HNSColors.failure[700]};
      color: ${HNSColors.failure[400]};
      font-weight: 700;
      border-bottom: none;
    }
  `;
}
